import { useQuery, useQueryClient } from "react-query";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import moment from "moment";
import axiosClient from "../../../../lib/axios";
import {
  DadosPixSucesso,
  IConsultarEmissaoPix,
} from "../../../../types/mutations/financeiro/emitir-pix";

export default function AguardandoPagamento({
  route,
  routeCode,
  onPixPago,
}: AguardandoPagamentoProps) {
  const queryClient = useQueryClient();

  const [dataConsulta, setDataConsulta] = useState<IConsultarEmissaoPix>();
  const [stop, setStop] = useState<boolean>(false);

  useQuery({
    queryKey: ["consultar-emissao-pix"],
    queryFn: () =>
      axiosClient.get(`${route}${routeCode}`),
    cacheTime: 0,
    refetchInterval: stop ? false : 3000,
    enabled: !dataConsulta || dataConsulta.status === "Aguardando pagamento",
    onSuccess({ data }) {
      setDataConsulta(data);
      if (data.status === "Pago") {
        setStop(true);
        queryClient.invalidateQueries(
          `comercial/detalhar-pedido`
        );
        onPixPago({
          recebido_por: data.usuario,
          data: moment().format("DD/MM/YYYY"),
          hora: moment().format("HH:mm:ss"),
          codigo: data.codigo,
          recibos: [
            {
              recibo: data.recibo,
              forma_recebimento: "Pix Instantâneo",
              valor: data.valor,
            },
          ],
        });
      }
    },
  });

  return (
    <Box display={"flex"}>
      {dataConsulta && (
        <>
          <Box
            alignSelf={"flex-start"}
            mt={0.5}
            mr={1}
            width={14}
            height={14}
            borderRadius={"50%"}
            bgcolor={"#FFD12E"}
          />
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Typography mb={-0.5} fontWeight={"bold"}>
              {dataConsulta.status}
            </Typography>
            <Typography variant="caption">
              Favor realizar o pagamento em até 5 minuto(s)
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}

interface AguardandoPagamentoProps {
  route: string;
  routeCode: string | number;
  onPixPago: (data: DadosPixSucesso) => void;
}
